import { createReactComponent } from '@tabler/icons-react';

export const IconCustomExportOff = createReactComponent(
  'outline',
  'customExportOff',
  'CustomExportOff',
  [
    [
      'path',
      {
        key: 'customExportOff-path',
        d: 'M15,8V7c0-0.5-0.2-1-0.6-1.4c-0.4-0.4-0.9-0.6-1.4-0.6H9 M15,15.4V17c0,0.5-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.4,0.6H4.9c-0.5,0-1-0.2-1.4-0.6c-0.4-0.4-0.6-0.9-0.6-1.4V7c0-0.5,0.2-1,0.6-1.4c0.3-0.3,0.6-0.5,1-0.6 M16,12h5 M21.1,12l-3-3 M21.1,12l-2.5,2.5 M2.9,2.9l18.1,18.1',
      },
    ],
  ]
);
